import type { Configuration, SurfaceOptionsGroup } from '~/types/configurator'

export default function useConfiguratorPanels(
  configuration: Ref<Configuration | null>,
  surfaceOptionsGroups: ComputedRef<Map<string, SurfaceOptionsGroup>>
) {
  const activePanel: Ref<string | null> = ref(null)

  const panels = computed(() => {
    if (!configuration.value) return new Map<string, string>([['', '']])

    return new Map(
      configuration.value.metasOptions
        .map((option) => ({
          id: `${METAS_OPTIONS_PANEL}${option.partCategoryNid}`,
          title: option.title,
        }))
        .concat(
          configuration.value.accessoriesOptions.map((option) => ({
            id: `${ACCESSORIES_OPTIONS_PANEL}${option.partCategoryNid}`,
            title: option.title,
          }))
        )
        .concat(
          [...surfaceOptionsGroups.value.entries()]
            .map(([key, value]) => {
              return [...value.surfaceOptionGroups.entries()].map(
                ([key2, value2]) => ({
                  id: `${SURFACES_OPTIONS_PANEL}${key}${key2}`,
                  title:
                    value2.surfaceType?.title ||
                    configuratorUtils.getAssignFabricTitle(
                      value2.surfaceOptions.at(0),
                      configuration.value?.accessoriesOptions
                    ) ||
                    '',
                })
              )
            })
            .flat()
        )
        .concat(
          configuration.value.surfacesOptions
            .filter((option) => option.optional)
            .map((option) => ({
              id: `${OPTIONAL_BASE_PARTS_PANEL}${option.partCategoryNid}`,
              title: option.title,
            }))
        )
        .map((panel) => [panel.id, panel.title])
    )
  })

  return { activePanel, panels: readonly(panels) }
}
